import { useInviteCandidateContext } from '../Contexts/InviteCandidateContext';
import CandidateAddSection from './Components/CandidateAddSection';
import CandidatesList from './Components/CandidatesList';

function AddCandidatesPanel() {
    const { candidates } = useInviteCandidateContext();

    return (
        <div className="bg-card rounded-xl border p-5">
            <CandidateAddSection />
            {candidates.length > 0 && <CandidatesList />}
        </div>
    );
}

export default AddCandidatesPanel;
